import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/events/groups.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getEventsGroupDetails = (_0) => __async(null, [_0], function* ({ lang, organizationsSlug }) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const search = new URLSearchParams();
    search.append("lang", locale);
    search.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    const base = `/organizations/${organizationsSlug}/event-group/details`;
    const res = yield fetchClient({
      url: `${base}?${decodeURIComponent(search.toString())}`,
      includeAuth: false
    });
    return res.data;
  } catch (error) {
    throw new Exception({ error, name: "getEventsGroupDetailsException" });
  }
});

export {
  getEventsGroupDetails
};
//# sourceMappingURL=chunk-QQQ24EF2.mjs.map